export default function AkinCetinkayaHomepage() {
  const courses = [
    {
      title: "E-Ticarete Giriş",
      description:
        "Sıfırdan başlayanlar için doğru ürün, doğru altyapı ve gerçekçi başlangıç kurgusu.",
    },
    {
      title: "Mağazadan Dijitale Geçiş",
      description:
        "Fiziksel mağaza deneyimini dijitalde yeniden kurmak isteyenler için yapılandırılmış yol haritası.",
    },
    {
      title: "Satış Problemlerini Çözmek",
      description:
        "Ziyaret var ama satış yoksa; teklif, güven, içerik ve dönüşüm tarafını birlikte ele alan dersler.",
    },
  ];

  const pillars = [
    {
      title: "Strateji",
      text: "Marka, ürün, hedef kitle ve büyüme kurgusunu birbirine bağlayan sade ama güçlü yapı.",
    },
    {
      title: "Uygulama",
      text: "Kurgu masada kalmaz. Site, içerik, reklam ve operasyon birlikte düşünülür.",
    },
    {
      title: "Deneyim",
      text: "Birden fazla sektörde edinilmiş saha tecrübesiyle, teoriden çok gerçek iş sonuçlarına odaklanılır.",
    },
  ];

  const works = [
    "E-ticaret altyapı kurulumu",
    "SEO ve içerik kurgusu",
    "Google Ads yönetimi",
    "Marka konumlandırma",
    "Dijital büyüme danışmanlığı",
    "Operasyon ve dönüşüm optimizasyonu",
  ];

  return (
    <div className="min-h-screen bg-black text-white selection:bg-white selection:text-black">
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.08),transparent_40%)]" />
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
          <div className="grid items-end gap-12 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <p className="mb-5 text-xs uppercase tracking-[0.35em] text-white/50">
                Akın Çetinkaya
              </p>
              <h1 className="max-w-4xl text-4xl font-semibold leading-tight md:text-6xl md:leading-[1.05]">
                E-ticaret, pazarlama ve dijital yapılanma üzerine sade ama güçlü bir alan.
              </h1>
              <p className="mt-6 max-w-2xl text-base leading-7 text-white/70 md:text-lg">
                Bu site; yaptığım çalışmaları, geliştirdiğim sistemleri ve hazırladığım kursları
                bir vitrin gibi değil, bir yolculuk alanı gibi sunmak için tasarlandı.
              </p>
              <div className="mt-8 flex flex-wrap gap-4">
                <a
                  href="#courses"
                  className="rounded-2xl border border-white bg-white px-6 py-3 text-sm font-medium text-black transition hover:scale-[1.02]"
                >
                  Kursları İzleyin
                </a>
                <a
                  href="#works"
                  className="rounded-2xl border border-white/20 px-6 py-3 text-sm font-medium text-white transition hover:border-white/40 hover:bg-white/5"
                >
                  Çalışmalarımı Keşfedin
                </a>
              </div>
            </div>

            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-1">
              <FlipCard
                frontTitle="Çalışmalarım"
                frontSubtitle="Projeler, markalar, sistemler"
                backText="Farklı sektörlerde kurduğum dijital yapılar, e-ticaret kurguları ve büyüme odaklı çalışmalar."
                buttonLabel="Çalışmalarımı Keşfedin"
                href="#works"
              />
              <FlipCard
                frontTitle="Kurslar"
                frontSubtitle="A'dan Z'ye ustalık odaklı içerikler"
                backText="Yeni başlayanlardan mağazasını dijitale taşımak isteyenlere kadar uzanan, yapılandırılmış eğitim setleri."
                buttonLabel="Kursları İzleyin"
                href="#courses"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.3em] text-white/45">Yaklaşım</p>
            <h2 className="mt-4 text-3xl font-semibold md:text-4xl">
              Klasik pazarlama dili yerine; tecrübe, kurgu ve uygulamaya dayalı bir anlatım.
            </h2>
            <p className="mt-5 text-base leading-7 text-white/70">
              Buradaki yapı yalnızca bir hizmet listesi ya da kurs vitrini değildir. Bir markanın
              nasıl kurulacağını, bir e-ticaret sisteminin nasıl ayakta kalacağını ve dijitalde
              nasıl gerçek bir karakter kazanacağını anlatan bütünlüklü bir çerçevedir.
            </p>
          </div>

          <div className="mt-10 grid gap-5 md:grid-cols-3">
            {pillars.map((item) => (
              <div
                key={item.title}
                className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 shadow-2xl shadow-black/20"
              >
                <h3 className="text-xl font-medium">{item.title}</h3>
                <p className="mt-3 text-sm leading-7 text-white/65">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="works" className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-white/45">Çalışmalarım</p>
              <h2 className="mt-3 text-3xl font-semibold md:text-4xl">Ne üzerine çalışıyorum?</h2>
            </div>
            <p className="max-w-2xl text-sm leading-7 text-white/60">
              E-ticaret kurulumundan içerik sistemine, reklam yönetiminden marka konumlandırmaya
              kadar uzanan bir yapı.
            </p>
          </div>

          <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {works.map((item) => (
              <div
                key={item}
                className="rounded-3xl border border-white/10 px-5 py-6 text-base text-white/85 transition hover:-translate-y-1 hover:border-white/30 hover:bg-white/[0.03]"
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="courses" className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.3em] text-white/45">Kurslar</p>
            <h2 className="mt-3 text-3xl font-semibold md:text-4xl">
              Ders satmaktan çok, bir ustalık alanı kurmak.
            </h2>
            <p className="mt-5 text-base leading-7 text-white/70">
              Kurslar; yüzeysel motivasyon başlıklarıyla değil, sıfırdan kurulum, karar verme,
              ürün yapısı, operasyon, içerik, güven ve satış mantığı gibi gerçek başlıklarla ilerler.
            </p>
          </div>

          <div className="mt-10 grid gap-5 lg:grid-cols-3">
            {courses.map((course) => (
              <div
                key={course.title}
                className="rounded-3xl border border-white/10 bg-white/[0.03] p-6"
              >
                <h3 className="text-xl font-medium">{course.title}</h3>
                <p className="mt-4 text-sm leading-7 text-white/65">{course.description}</p>
                <button className="mt-6 rounded-2xl border border-white/15 px-4 py-2 text-sm text-white transition hover:border-white/35 hover:bg-white/5">
                  İncele
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.03] p-8 md:p-10">
            <p className="text-xs uppercase tracking-[0.3em] text-white/45">İletişim</p>
            <div className="mt-4 grid gap-6 md:grid-cols-[1fr_auto] md:items-end">
              <div>
                <h2 className="text-3xl font-semibold md:text-4xl">
                  Bir marka, bir sistem ya da bir dönüşüm kurgusu üzerine konuşabiliriz.
                </h2>
                <p className="mt-4 max-w-2xl text-base leading-7 text-white/70">
                  Bu alan daha sonra form, sosyal bağlantılar, e-posta ve takvim entegrasyonlarıyla
                  genişletilebilir.
                </p>
              </div>
              <a
                href="mailto:info@akincetinkaya.com"
                className="inline-flex rounded-2xl border border-white bg-white px-6 py-3 text-sm font-medium text-black transition hover:scale-[1.02]"
              >
                İletişime Geç
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function FlipCard({ frontTitle, frontSubtitle, backText, buttonLabel, href }) {
  return (
    <div className="group [perspective:1200px]">
      <div className="relative h-[260px] w-full rounded-[2rem] transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
        <div className="absolute inset-0 rounded-[2rem] border border-white/10 bg-white/[0.04] p-7 [backface-visibility:hidden]">
          <div className="flex h-full flex-col justify-between">
            <div>
              <p className="text-sm uppercase tracking-[0.28em] text-white/35">Akın Çetinkaya</p>
              <h3 className="mt-5 text-3xl font-semibold">{frontTitle}</h3>
            </div>
            <p className="text-sm leading-7 text-white/60">{frontSubtitle}</p>
          </div>
        </div>

        <div className="absolute inset-0 rounded-[2rem] border border-white/15 bg-white text-black p-7 [backface-visibility:hidden] [transform:rotateY(180deg)]">
          <div className="flex h-full flex-col justify-between">
            <p className="text-sm leading-7 text-black/75">{backText}</p>
            <a
              href={href}
              className="inline-flex w-fit rounded-2xl border border-black/10 bg-black px-5 py-3 text-sm font-medium text-white"
            >
              {buttonLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
